import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Space } from 'antd';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useParams } from "react-router";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { usePermissions } from '../../../Services/PermissionsContext';
import { hasPermission } from '../../../Services/checkPermissions';
import TabMenu from './TabMenu';

const PhlebloPaymentReport = () => {
  const permissions = usePermissions();
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ search: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (organization) {
      loadPayments(currentPage, pageSize);
    }
  }, [organization, currentPage, pageSize]);

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const loadPayments = (page = 1, perPage = pageSize) => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'phlebloweeklypatment');

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        organization_id: organization,
        page,
        per_page: perPage,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        setData(result.data || []);
        setTotalRecords(result.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'phleblopayoutsearch', {
      method: 'POST',
      body: JSON.stringify({
        search: formData.search,
        user_id: authService.getCurrentadmin().UserInfo.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.data || []);
        setTotalRecords(result.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const updateOrderStatus = (record) => {
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'ordersweeklypayment/' + record.assign_to, {
      method: 'PUT',
      // body: JSON.stringify({
      //   order_status_id: record.order_status_id == 6 ? 7 : null,
      //   lab_order_status_id: record.lab_order_status_id == 6 ? 7 : null,
      // }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        loadPayments(currentPage, pageSize);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      render: (text) => <span>{text || '-'}</span>,
      sorter: (a, b) => (a.transaction_id || '').localeCompare(b.transaction_id || ''),
    },
    {
      title: "Total Completed Orders",
      dataIndex: "total_orders",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => (a.invoice_number || '').localeCompare(b.invoice_number || ''),
    },

    {
      title: "Due Amount",
      dataIndex: "total_due_amount",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => parseFloat(a.total_due_amount) - parseFloat(b.total_due_amount),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => {
       

        return (
          <Space size="middle">

              <span
                className='status-btn-green'
                style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
                onClick={() => updateOrderStatus(record)}
              >
                Make Payment
              </span>
          
          </Space>
        );
      },
    },
  ];

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <TabMenu name="pending-payout-report" />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Phlebotomist Payout Report</h3>
            </div>
          </div>
          <div className='flex-cont just-cont-left bord-botm'>
            <div className='filter-search'>
              <input
                type='text'
                className='category-search'
                placeholder='Search by date'
                onChange={handleInputChange}
                name="search"
                id="search"
              />
              <Button type='submit' onClick={handleSubmit}>Search</Button>
            </div>
          </div>
          <div className='hospitals-table' id='hospitals_table'>
            <Table
              dataSource={data}
              columns={columns}
              pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalRecords,
                  showSizeChanger: true,
                  pageSizeOptions: ['5', '10', '20', '50'],
                  onChange: handlePageChange,
                  onShowSizeChange: handlePageChange,  // This ensures pageSize changes correctly
                }}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhlebloPaymentReport;
